<template>
  <div class="view-marketplace container-fluid py-5">
    <h3 class="mb-4">Produtos</h3>

    <form-group
      id="search"
      class="flex-fill mb-0"
      v-model="search"
      placeholder="Pesquisar"
    />

    <action-dispatcher action="marketplace/getProducts" ref="actionDispatcher">
      <div class="row">
        <div
          v-for="(product, index) in filteredProducts"
          :key="index"
          class="col-lg-3 col-md-6 py-4 d-flex aling-items-strech"
        >
          <product-link :product="product" class="w-100" />
        </div>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import ProductLink from "../components/marketplace/ProductLink";
import { mapState } from "vuex";

export default {
  components: { ProductLink },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    ...mapState("marketplace", ["products"]),
    filteredProducts() {
      return this.products.filter(p =>
        p.title.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.view-marketplace {
  .card {
    background: rgba(0, 0, 0, 0.2);
    border-color: white;
    border-radius: 6px;
  }

  hr {
    border-color: rgba(255, 255, 255, 0.7);
  }

  ::v-deep .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: unset;
  }
}
</style>
